module.exports = __webpack_public_path__ + "static/media/berezovska-grave.6c93fdc8.jpg";